import React, { Component } from "react";
import DataGrid, {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";
export class ServiceProviderComponent extends Component {
  static displayName = ServiceProviderComponent.name;
  constructor(props) {
    super(props);
    this.state = {
      serviceProviderGridDataSource: null,
    };
    this.refDataGrid = React.createRef(null);
    this.isComponentDidMounted = false;
  }
  componentDidMount() {
    try {
      if (this.isComponentDidMounted) {
        return;
      }
      document.querySelector("#lblPageTitle").innerHTML = `Local Vender`;
      setTimeout(async () => {
        await this.getServiceProvider();
      }, 0);
      this.isComponentDidMounted = true;
    } catch (error) {
      console.log(error);
    }
  }
  getServiceProvider = async () => {
    try {
      const response = await axiosGet("Account/ServiceProviders");
      this.setState((prev) => ({
        ...prev,
        serviceProviderGridDataSource: response?.payload ?? [],
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getServiceProvider function",
        err,
      );
    }
  };
  getAccountTracking = (e, currentPageName, data) => {
    e.preventDefault();
    sessionStorage.setItem("session_PageName", currentPageName);
    this.props.history.push({
      pathname: "/tracking",
      state: {
        transporterId: data.transportId,
        sourceUrl: "/service-providers",
      },
    });
  };
  render() {
    const renderTrackAccount = (data) => {
      return (
        <a
          href="#"
          onClick={(e) => this.getAccountTracking(e, "Tracking", data.data)}
          title={`View ${data.data.transportName} fleet on map`}
          style={{
            textDecoration: "none",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "26px",
              height: "26px",
              borderRadius: "6px",
              background: "linear-gradient(135deg, #8E6448, #b07d5c)",
              color: "#fff",
              flexShrink: 0,
            }}
          >
            <i className="fas fa-truck" style={{ fontSize: "0.65rem" }} />
          </span>
          <span
            style={{ fontWeight: 600, fontSize: "0.82rem", color: "#5c3a1e" }}
          >
            {data.data.transportName}
          </span>
          <i
            className="fas fa-external-link-alt"
            style={{ fontSize: "0.6rem", color: "#b07d5c", marginLeft: "2px" }}
          />
        </a>
      );
    };

    return (
      <>
        <style>{`
          /* ── Service Provider — theme matching sidebar #8E6448 ── */
          .ca-grid-wrap .dx-header-row td {
            background-color: #fff0e6 !important;
            color: #000000 !important;
            font-size: 0.76rem !important;
            font-weight: 600 !important;
            letter-spacing: 0.02em !important;
            border-color: rgba(255,255,255,0.15) !important;
          }
          .ca-grid-wrap .dx-datagrid-filter-row td {
            background-color: #f5ede4 !important;
          }
          .ca-grid-wrap .dx-datagrid {
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
          }
          .ca-grid-wrap .dx-toolbar {
            background: #fdf7f2 !important;
            border-bottom: 1px solid #e8d5c4 !important;
            padding: 0.35rem 0.6rem !important;
          }
        `}</style>
        <div className="card ca-grid-wrap">
          <div className="card-body">
            <DataGrid
              ref={this.refDataGrid}
              dataSource={this.state.serviceProviderGridDataSource}
              columnsAutoWidth={true}
              showColumnLines={true}
              showRowLines={true}
              showBorders={true}
              rowAlternationEnabled={false}
              allowColumnResizing={true}
              onCellPrepared={(e) => {
                if (e.rowType === "header") {
                  e.cellElement.style.backgroundColor = "#fff0e6";
                  e.cellElement.style.color = "#000000";
                }
              }}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift({
                  location: "after",
                  widget: "dxButton",
                  options: {
                    icon: "refresh",
                    onClick: async (e) => {
                      e.component.option("icon", "fas fa-spinner fa-spin");
                      await this.getServiceProvider();
                      e.component.option("icon", "refresh");
                    },
                  },
                });
              }}
            >
              <Column
                dataField="transportId"
                caption="Transport #"
                allowSearch={true}
                headerFilter={{ allowSearch: true }}
                width={"auto"}
                dataType={"string"}
              />
              <Column
                dataField="transportName"
                caption="Transporter"
                headerFilter={{ allowSearch: true }}
                allowSearch={true}
                cellRender={renderTrackAccount}
              />
              <Column
                dataField="contactNumber"
                caption="Contact No"
                headerFilter={{ allowSearch: true }}
                allowSearch={true}
              />
              <Column
                dataField="email"
                caption="Email"
                headerFilter={{ allowSearch: true }}
                allowSearch={true}
              />
              <Column
                dataField="address"
                caption="Address"
                headerFilter={{ allowSearch: true }}
                allowSearch={true}
              />

              <SortByGroupSummaryInfo summaryItem="count" />
              <GroupPanel visible={false} />
              <HeaderFilter visible={true} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Grouping autoExpandAll={true} />
              <Paging defaultPageSize={20} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[10, 20, 50]}
                showInfo={true}
                visible={true}
              />
              <Export
                enabled={true}
                allowExportSelectedData={false}
                fileName="ServiceProvider"
              />
            </DataGrid>
          </div>
        </div>
      </>
    );
  }
}
